import {
  FETCH_STATIC_DATA_STARTED,
  FETCH_STATIC_DATA_SUCCEEDED,
  FETCH_STATIC_DATA_FAILED,
} from 'platform/site-wide/drupal-static-data/actions';
import { fetchDrupalStaticDataFile } from './fetch';

// Cache to prevent duplicate fetches of the same static data file.
// Keys are fileNames, values are { promise, data } objects.
const fetchCache = {};

export const resetStaticDataFetchCache = () => {
  Object.keys(fetchCache).forEach(key => delete fetchCache[key]);
};

export const connectDrupalStaticDataFile = async (dispatch, dataFile) => {
  if (!dataFile) {
    return;
  }

  const { fileName, preProcess, statePropName } = dataFile;

  // If already fetched and cached, dispatch the cached result without re-fetching.
  if (fetchCache[fileName]?.data) {
    const { data: cachedData } = fetchCache[fileName];
    const data = preProcess ? preProcess(cachedData) : cachedData;
    dispatch({
      type: FETCH_STATIC_DATA_SUCCEEDED,
      payload: {
        statePropName,
        data,
      },
    });
    return;
  }

  // If a fetch is already in flight, wait for it instead of starting another.
  if (fetchCache[fileName]?.promise) {
    const json = await fetchCache[fileName].promise;
    if (json && !(json instanceof Error)) {
      let data = json;
      if (preProcess) {
        data = preProcess(json);
      }
      dispatch({
        type: FETCH_STATIC_DATA_SUCCEEDED,
        payload: {
          statePropName,
          data,
        },
      });
    } else {
      dispatch({
        type: FETCH_STATIC_DATA_FAILED,
        payload: {
          statePropName,
          error: json instanceof Error ? json : new Error('Fetch failed'),
        },
      });
    }
    return;
  }

  dispatch({
    type: FETCH_STATIC_DATA_STARTED,
    payload: {
      statePropName,
      data: [],
    },
  });

  fetchCache[fileName] = {
    promise: fetchDrupalStaticDataFile({ fileName }),
  };

  const json = await fetchCache[fileName].promise;

  if (json && !(json instanceof Error)) {
    fetchCache[fileName].data = json;
    let data = json;
    if (preProcess) {
      data = preProcess(json);
    }
    dispatch({
      type: FETCH_STATIC_DATA_SUCCEEDED,
      payload: {
        statePropName,
        data,
      },
    });
  } else {
    // Clear cache entry on failure so subsequent calls can retry.
    delete fetchCache[fileName];
    dispatch({
      type: FETCH_STATIC_DATA_FAILED,
      payload: {
        statePropName,
        error: json instanceof Error ? json : new Error('Fetch failed'),
      },
    });
  }
};
